import styled from 'styled-components';
import { stacked } from 'app/shared/styles/_spacing';

export const FlexSection = styled.section`
  display: flex;
  ${stacked._1x};
`;
